import React from 'react';
import { Trash2, MoveVertical, Info } from 'lucide-react';

interface SpacerBlockData {
  height: number;
}

interface SpacerBlockProps {
  data: SpacerBlockData;
  onChange: (data: SpacerBlockData) => void;
  onDelete: () => void;
  isPreview?: boolean;
}

const SpacerBlock: React.FC<SpacerBlockProps> = ({ data, onChange, onDelete, isPreview }) => {
  if (isPreview) {
    return <div style={{ height: `${data.height}px` }} />;
  }

  return (
    <div className="border border-gray-200 rounded-lg p-6 bg-white">
      <div className="flex justify-between items-center mb-4">
        <div className="flex items-center gap-2">
          <h3 className="font-semibold text-gray-900">ช่องว่าง</h3>
          <div className="relative">
            <Info className="w-4 h-4 text-gray-400 cursor-help peer" />
            <div className="absolute left-0 top-6 w-64 bg-gray-900 text-white text-xs rounded-lg p-3 opacity-0 invisible peer-hover:opacity-100 peer-hover:visible transition-all duration-200 z-10 shadow-xl pointer-events-none">
              <p className="font-semibold mb-1">เพิ่มพื้นที่ว่าง</p>
              <p className="text-gray-300">เพิ่มช่องว่างระหว่างเนื้อหา ช่วยจัดระยะห่างและเพิ่มความสวยงามให้หน้า Sale Page</p>
            </div>
          </div>
        </div>
        <button
          onClick={onDelete}
          className="text-red-500 hover:text-red-700 p-2 hover:bg-red-50 rounded-lg transition-colors"
        >
          <Trash2 className="w-5 h-5" />
        </button>
      </div>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            ความสูง: {data.height}px
          </label>
          <input
            type="range"
            min="10"
            max="200"
            step="10"
            value={data.height}
            onChange={(e) => onChange({ height: parseInt(e.target.value) })}
            className="w-full"
          />
          <div className="flex justify-between text-xs text-gray-500 mt-1">
            <span>10px</span>
            <span>200px</span>
          </div>
        </div>

        <div className="pt-4 border-t border-gray-200">
          <p className="text-sm text-gray-600 mb-2">ตัวอย่าง:</p>
          <div className="border-2 border-dashed border-gray-300 rounded-lg flex items-center justify-center bg-gray-50" style={{ height: `${Math.min(data.height, 100)}px` }}>
            <div className="text-center text-gray-400">
              <MoveVertical className="w-6 h-6 mx-auto mb-1" />
              <span className="text-xs">{data.height}px</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SpacerBlock;
